exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:991px){.vue-star-rating[data-v-62af682b]{justify-content:center}}", ""]);

// exports
